import AWS from 'aws-sdk';
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import 'amazon-cognito-js';

export const appConfig = {
  region: 'us-east-1',
  IdentityPoolId: 'us-east-1:e08f84c4-f1eb-44aa-9e48-114c5dcd9af3',
  UserPoolId: 'us-east-1_kHKUcc71r',
  ClientId: '1g3p60uh814fe9jgo5c36ncvv5',
};

appConfig.LoginId = `cognito-idp.${appConfig.region}.amazonaws.com/${appConfig.UserPoolId}`;

AWS.config.region = appConfig.region;
AWS.config.credentials = new AWS.CognitoIdentityCredentials({
  IdentityPoolId: appConfig.IdentityPoolId,
});
AWS.config.setPromisesDependency();

export const poolData = {
  UserPoolId: appConfig.UserPoolId,
  ClientId: appConfig.ClientId,
};

export const userPool = new CognitoUserPool(poolData);

export default AWS;



// WEBPACK FOOTER //
// ./src/config/AWSOps.js